import React from "react"
import { cn } from "../../lib/utils"

interface TextProps extends React.HTMLAttributes<HTMLParagraphElement> {
    variant?: "default" | "label" | "secondary"
    size?: "sm" | "md" | "lg"
    children: React.ReactNode
}

export const Text = React.forwardRef<HTMLParagraphElement, TextProps>(
    ({ className, variant = "default", size = "md", children, ...props }, ref) => {
        const variants = {
            default: "text-gray-900 dark:text-gray-100",
            label: "text-gray-900 dark:text-gray-100 font-medium",
            secondary: "text-gray-500 dark:text-gray-400",
        }
        const sizes = {
            sm: "text-sm",
            md: "text-base",
            lg: "text-lg",
        }

        return (
            <p
                ref={ref}
                className={cn(variants[variant], sizes[size], className)}
                {...props}
            >
                {children}
            </p>
        )
    }
)
Text.displayName = "Text"
